<template>
    <div>
        <div :class='{"h-toolbarBg": !hasBorder}'>
            <ejs-toolbar v-if='update'>
              <e-items>
                <e-item  prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Software.upload")' :click='click' id='browse'></e-item>
                <e-item  prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Software.delete")' :click='remove' ></e-item>
              </e-items>
            </ejs-toolbar>
            <div :class='[hasBorder ? "h-borderBox-top" : "h-inputBox"]'>
                <div :class='{"col-xs-12 col-sm-12 col-lg-12 col-md-12": hasBorder}'>
                    <ejs-textbox :placeholder='$t("System.inputTip7")' @keydown.enter.native="search" v-model='input' />
                </div>
            </div>
        </div>
        <div v-if="update">
          <ejs-grid ref='grid' :dataSource='data' :class='{ "h-borderBox-content": hasBorder }' :pageSettings='pageSettings' :allowPaging='false'
            childMapping="subtasks" height="calc(100vh - 180px)" :allowResizing='true'>
              <e-columns>
                  <e-column type='checkbox' width='10' ></e-column>
                  <e-column field='pkgName' :headerText='$t("Software.td_packageName")' width='5%'></e-column>
                  <e-column field='pkgTag' :headerText='$t("Software.td_packageTag")' width='5%' ></e-column>
                  <e-column field='pkgVer' :headerText='$t("Software.td_packageVer")' width='5%' ></e-column>
                  <e-column v-if='update' field='pkgMadeTime' :headerText='$t("Software.td_createTime")' width='5%' ></e-column>
              </e-columns>
          </ejs-grid>
        </div>
        <div v-else>
          <ejs-grid ref='grid' :dataSource='data' :class='{ "h-borderBox-content": hasBorder }' :pageSettings='pageSettings' :allowPaging='false'
            childMapping="subtasks" :allowResizing='true' height ='229'>
              <e-columns>
                  <e-column type='checkbox' width='10' ></e-column>
                  <e-column field='pkgName' :headerText='$t("Software.td_packageName")' width='8%' clipMode='EllipsisWithTooltip'></e-column>
                  <e-column field='pkgTag' :headerText='$t("Software.td_packageTag")' width='5%' clipMode='EllipsisWithTooltip'></e-column>
                  <e-column field='pkgVer' :headerText='$t("Software.td_packageVer")' width='8%' clipMode='EllipsisWithTooltip'></e-column>
                  <e-column v-if='update' field='pkgMadeTime' :headerText='$t("Software.td_createTime")' width='1%' clipMode='EllipsisWithTooltip'></e-column>
              </e-columns>
          </ejs-grid>
        </div>
    </div>
</template>

<script>
let dataSource = [];
import { Resize } from "@syncfusion/ej2-vue-grids";
export default {
  name: 'verlib-list',
  props: [
    'update',
    'hasBorder',
    'click',
    'showToast'
  ],
  data() {
    return {
      input:'',
      data: [],
      pageSettings: { pageSizes: true, pageCount: 4, pageSize: 20 },
    };
  },
  provide: {
      grid: [Resize]
  },
  mounted() {
    this.queryMethod();
  },
  methods: {
    queryMethod() {
      let para={
          versionId: '',
          pagName: '',
          verPagType: '',
          systemId: '1',
          page: {
            pageNo: 1,
            pageSize: 25,
          },
      }
      this.$axios.post('/lte/ems/verlib_new/queryList', para).then((response) => {
        if(response.data.errorCode == 'SUCCESS')
        {
          dataSource = response.data.resultVal.result;
          this.data = dataSource;
        }
      });
    },
    getSelect() {
      return this.$refs.grid.getSelectedRecords();
    },
    remove() {
      const delIds = this.$refs.grid.getSelectedRecords().map(x => x.pkgId +'');
      if(delIds.length == 0)
      {
        this.showToast('warning',`${this.$t("System.selectDelObj")}`);
        return;
      }
      this.$layer.confirm({
          msg: this.$t('LteUser.delConfirm'),
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
              this.$axios.post('/lte/ems/verlib_new/delVersionAction', delIds).then((response) => {
                if(response.status == 200)
                {
                  if(response.data.errorCode == 'SUCCESS')
                  {
                      this.showToast('success', `${this.$t('Common.tips.success')}`);
                  }
                  else
                  {
                      this.showToast('error',response.data.errorString);
                  }
                }
                this.queryMethod()
              });
            }
          },
          btn1: {
            msg: this.$t('MCS.cancle')
          }
      });
    },
    search(args) {
      if(this.input === '') {
          this.data = dataSource;
      }
      else {
        var filterdata = dataSource.filter( item => {
            let columntext = Array.from(this.$refs.grid.getColumns(), x => {
              return x.field;
            });
            let feildData = Array.from(columntext, x => {
              return item[x] === null ? '' : item[x] +'';
            });
            let filres = false;
            feildData.forEach(item => {
              if(item.indexOf(this.input) > -1)
              {
                filres = true;
              }
            });
            return filres;
        }).map( item => { return item });
        this.data = filterdata;
      }
    }
  }
};
</script>